var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.375 20L30.025 10.625C29.8835 8.59245 30.3679 6.56532 31.4129 4.81626C32.4579 3.06719 34.0134 1.68008 35.8703 0.84149C37.7272 0.00289535 39.7964 -0.246963 41.7995 0.125521C43.8026 0.498004 45.6437 1.47496 47.075 2.925C48.5203 4.35997 49.493 6.20205 49.863 8.20484C50.233 10.2076 49.9826 12.2757 49.1453 14.1323C48.3081 15.9889 46.9239 17.5457 45.1779 18.5942C43.4319 19.6428 41.4073 20.1333 39.375 20ZM4.62498 38.25L27.625 15.275L34.7 22.35L11.7 45.35L4.64998 38.25H4.62498ZM1.12498 45.325L6.39998 40.025L9.94998 43.575L4.64998 48.875L1.09998 45.325H1.12498ZM25 37.5L30 32.5V50H25V37.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMic);
export default __webpack_public_path__ + "static/media/mic.7b6b9521aa915c9029cf8d2d4601c44b.svg";
export { ForwardRef as ReactComponent };